<template>
    <Transition>
        <div
            v-if="showBasketPopover"
            id="basketPopover"
            ref="basketPopover"
            class="bg-white border rounded position-absolute shadow-lg"
        >
            <div class="arrow-up position-absolute"></div>
            <div>
                <div class="text-start p-3 pb-0 d-flex align-items-center justify-content-between">
                    <b class="text-18">Your basket</b>
                    <div @click="showBasketPopover = false">
                        <i class="fa-kit fa-close cursor-pointer"></i>
                    </div>
                </div>
                <hr class="mx-3 mt-2 mb-0">
                <div v-if="basket?.products?.length > 0" class="p-3">
                    <template v-if="tyresInBasket?.length > 0">
                        <p class="mb-0 small text-start">Your selected tyres</p>
                        <div v-for="(product, index) in basket.products" :key="product.st_code">
                            <div v-if="product.product_type != 'service'">
                                <div class="d-flex justify-content-between">
                                    <b>{{ product.brand }}</b>
                                    <b>£{{ product.display_total }}</b>
                                </div>
                                <div class="d-flex justify-content-between align-items-center">
                                    <div class="d-flex flex-column text-start">
                                        <p class="mb-0">{{ product.tyre_range }}</p>
                                        <small>{{ product.description }}</small>
                                    </div>
                                    <div>
                                        <p class="mb-0">Qty: {{ product.quantity }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr>
                    </template>
                    <template v-if="basketServices?.length > 0">
                        <p class="mb-0 small text-start">Your selected services</p>
                        <div v-for="(product, index) in basketServices" :key="product.st_code">
                            <div v-if="product.product_type == 'service'">
                                <div class="d-flex justify-content-between">
                                    <b class="pe-2 text-start">{{ product.service_name }}</b>
                                    <template v-if="product.price_type === 'fixed'"><b>£{{ product.retail }}</b></template>
                                    <template v-else>
                                        <b>£{{ parseFloat(product.retail * (basket.total_tyres != 0 ? basket.total_tyres : 1)).toFixed(2) }}</b>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <hr>
                    </template>
                    <div class="text-start" v-if="basket.home_delivery == 0 && basket?.fitter_id">
                        <p class="d-block mb-0 small">Your selected fitter</p>
                        <div v-if="basket?.fitter?.name">
                            <b>{{ basket.fitter.name }}</b>
                        </div>
                        <div v-if="basket?.app_date">
                            <p class="mb-0">on {{ formattedDate }}</p>
                        </div>
                        <hr>
                    </div>
                    <div class="d-flex justify-content-between align-items-center">
                        <b>Total</b>
                        <b>£{{ basket.sub_total }}</b>
                    </div>
                    <hr>
                    <div class="d-flex justify-content-between align-items-center">
                        <a href="/basket" class="p-2 text-center btn btn-secondary w-100 rounded px-4 text-decoration-none text-18">View basket</a>
                    </div>
                </div>
                <div class="mb-2" v-else>
                    <p class="my-2">Your basket is empty.</p>
                    <a href="/basket" class="p-2 text-center btn btn-secondary w-auto rounded px-4 text-decoration-none text-18">View basket</a>
                </div>
            </div>
        </div>
    </Transition>
    <div v-if="showBasketPopover" class="outside" @click="showBasketPopover = false"></div>
</template>

<script>
    import dayjs from '@frontend/node_modules/dayjs';

    export default {
        props: ['basket'],
        data() {
            return {
                showBasketPopover: false
            }
        },
        mounted() {
            this.emitter.on('toggleBasketPopover', data => {
                this.showBasketPopover = !this.showBasketPopover;
            });
        },
        computed: {
            basketServices() {
                let vm = this;
                return this.basket?.products?.filter((upsell) => {
                    return upsell.product_type == 'service';
                });
            },
            tyresInBasket() {
                let filtered = this.basket?.products.filter(product => product?.product_type == 'product');
                return filtered;
            },
            formattedDate() {
                if(this.basket?.app_date) {
                    var advancedFormat = require('@frontend/node_modules/dayjs/plugin/advancedFormat');
                    dayjs.extend(advancedFormat);

                    return dayjs(this.basket.app_date).format('dddd Do MMMM YYYY');
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '@frontendAssets/sass/_variables.scss';

    #basketPopover {
        z-index: 99999;
        min-width: 315px;
        right: -96px;
        top: 40px;
        .arrow-up {
            background: #fff;
            right: 95px;
            &::after {
                content: "";
                position: absolute;
                width: 0;
                height: 0px;
                border: 7px solid #eee;
                border-color: transparent transparent #fff #fff;
                transform-origin: 0 0;
                transform: rotate(135deg);
                box-shadow: -2px 2px 2px 0 rgba(0, 0, 0, 0.1);
            }
        }
    }

    .v-enter-active,
    .v-leave-active {
        transition: opacity 0.5s ease;
    }

    .v-enter-from,
    .v-leave-to {
        opacity: 0;
    }
    .outside {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0px;
        left: 0px;
        z-index:99998;
      }
</style>